import usePermissions from '@/hooks/usePermissions';

import { OrganizationStatus, UserPermissions } from 'types';

import { useAuth } from './authProvider';
import { isPalmettoFinanceUser } from './RequirePalmettoFinanceUser';

export const useCanPerformActionForNoNewSalesOrgStatus = () => {
  const { claims } = useAuth();
  const userPermissions = usePermissions();
  const isLightReachAdmin = isPalmettoFinanceUser(claims) && userPermissions.includes(UserPermissions.admin);
  return isLightReachAdmin
    ? true
    : claims?.orgStatus !== OrganizationStatus.noNewSales && claims?.rootOrgStatus !== OrganizationStatus.noNewSales;
};
